import React, { useState, useRef } from 'react'
import axios from 'axios'
import ReactToPrint from 'react-to-print'

import { GrClose, GrDocumentPdf } from 'react-icons/gr'
import { HiOutlineBanknotes } from 'react-icons/hi2'
import { RiShieldKeyholeLine } from 'react-icons/ri'
import { useStateValue } from '../../Utils/StateProvider'
import { useCookies } from 'react-cookie'

import logo from '../../Contents/images/o/logo-grey.png'
import { BsArrowDown, BsArrowUp } from 'react-icons/bs'
import { capitalizeWords, formatToCurrency } from '../../Utils/general'
import { TfiPrinter } from 'react-icons/tfi'

const Request = () => {
    const [{ site, url, customer }, payload] = useStateValue()
    const [showAddStatement, setShowAddStatement] = useState(false)
    const [records, setRecords] = useState([])
    const [recordRange, setRecordRange] = useState({})
    const [cookies] = useCookies(['bearerToken'])

    let statementData = useRef(null)

    const close = () => {
        setRecords([])
        setRecordRange({})
        setShowAddStatement(false)
    }

    const getRecords = async () => {
        const limit = 100
        const options = {
            headers: {
                Authorization: `Bearer ${cookies.bearerToken}`
            }
        }

        let conditions = []
        if (recordRange.from) conditions.push(['timestamp', '>=', recordRange.from])
        if (recordRange.to) conditions.push(['timestamp', '<=', recordRange.to])

        const data = conditions.length > 0 ? {
            uid: customer?.uid,
            conditions,
            limit,
            page: 1
        } : {
            uid: customer?.uid,
            limit,
            page: 1
        }
        
        try {
            const _transactions = await axios.post(`${url}/api/tx/page`, data, options)

            setRecords(_transactions.data.transactions)
        } catch(err) {
            payload({
                type: 'SET_NOTIFY',
                data: {
                    text: err.response.data.message,
                    type: 'error'
                }
            })
            setRecordRange({})
            setShowAddStatement(false)
        }
    }

    return (
        <div className='display'>
            <div className="request-container">
                <ul className="requests">
                    <li onClick={() => setShowAddStatement(true)}>Account Statement <GrDocumentPdf /></li>
                    <li>Cheque Book <HiOutlineBanknotes /></li>
                    <li>Token Hardware <RiShieldKeyholeLine /></li>
                </ul>
            </div>

            {
                showAddStatement && (
                    <div className="pdf-form">
                        <div className="form-box">
                            <GrClose onClick={() => setShowAddStatement(false)} />
                            <div className="form-container">
                                <div className="form-row">
                                    <div className="form-column">
                                        <label htmlFor="from">From:</label>
                                        <input type="date" name="from" id="from" value={recordRange.from || ''} onChange={e => setRecordRange({...recordRange, from: e.target.value})} />
                                    </div>
                                    <div className="form-column">
                                        <label htmlFor="to">To:</label>
                                        <input type="date" name="to" id="to" value={recordRange.to || ''} onChange={e => setRecordRange({...recordRange, to: e.target.value})} />
                                    </div>
                                </div>
                                <div className="form-row">
                                    <button onClick={getRecords}>Preview</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                records.length > 0 && (
                    <div className="print-tx-cover">
                        <GrClose onClick={close} />
                        <ReactToPrint 
                            trigger={() => (
                                <button className='print-btn'>Print Statement <TfiPrinter /> </button>
                            )}
                            content={()=> statementData}
                            documentTitle="Account Statement"
                            pageStyle="print"
                            onAfterPrint={() => console.log('printed')}
                        />
                        <div className="statement" ref={e => (statementData = e)}>
                            <div className="statement-header">
                                <div className="left">
                                    <img src={logo} alt={site?.name} width='250' />
                                </div>
                                <div className="right">
                                    <h3>Head Quarters (HQ)</h3>
                                    <p>{site.address}</p>
                                </div>
                            </div>
                            <div className="statement-summary">
                                <div className="summary">
                                    <p>Sent: <strong style={{color: 'red', opacity: 0.6}}>{
                                        formatToCurrency(
                                            records?.filter(r => r.transaction_type === 'debit')
                                                .map(r => r.amount)
                                                .reduce((a, b) => a + b, 0), 
                                            customer?.currency
                                        )}</strong></p>
                                    <p>Received: <strong style={{color: 'green', opacity: 0.6}}>{
                                        formatToCurrency(
                                            records?.filter(r => r.transaction_type === 'credit')
                                                .map(r => r.amount)
                                                .reduce((a, b) => a + b, 0), 
                                            customer?.currency
                                        )
                                        }</strong></p>
                                    <p>
                                        Printed on {new Date().toLocaleString()}
                                    </p>
                                </div>
                            </div>
                            <div className="title-bar">
                                <h1>Account Statement</h1>
                                <h3>{capitalizeWords(customer?.fname)} {capitalizeWords(customer?.lname)}</h3>
                                <h3>{customer?.account}</h3>
                            </div>
                            <hr />
                            <div className="statement-table">
                                <table className=''>
                                    <thead>
                                        <tr>
                                            <th>Name & Account</th>
                                            <th>Tx Reference</th>
                                            <th>Tx Amount & Tx Type</th>
                                            <th>Tx Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        records?.map((record, i) => (
                                            <tr>
                                                <td>
                                                    <p>{capitalizeWords(record.account_name)}</p>
                                                    <strong>{record?.account_number}</strong>
                                                </td>
                                                <td>
                                                    <p>{record?.tid}</p>
                                                </td>
                                                <td className={record?.transaction_type.toLowerCase()}>
                                                { record?.transaction_type.toLowerCase() === 'credit' ? <BsArrowDown /> : <BsArrowUp />}
                                                    <strong>{formatToCurrency(record?.amount, customer?.currency)}</strong>
                                                </td>
                                                <td>
                                                    <strong>{new Date(record?.timestamp).toLocaleString()}</strong>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default Request
